import tw, { styled } from 'twin.macro';

import { pseudoStyles } from '@sopranodesign/pulse-components';

const HeaderButton = styled.button`
  ${tw`p-0 border-none bg-transparent relative cursor-pointer rounded flex`}
  border: 1px solid transparent;
  svg {
    ${tw`opacity-75`};
  }
  &:hover svg {
    ${tw`opacity-100`};
  }
  > * {
    pointer-events: none;
  }
  ${pseudoStyles}
`;

export default HeaderButton;
